import { render, staticRenderFns } from "./ForgePolygonViewer.vue?vue&type=template&id=1942c264&scoped=true"
import script from "./ForgePolygonViewer.vue?vue&type=script&lang=js"
export * from "./ForgePolygonViewer.vue?vue&type=script&lang=js"
import style0 from "./ForgePolygonViewer.vue?vue&type=style&index=0&id=1942c264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942c264",
  null
  
)

export default component.exports